export enum checkinTypes {
  CREATE_CHECK_IN = 'CREATE_CHECK_IN',
  CHECK_IN_SUCCESS = 'CHECK_IN_SUCCESS',
  CHECK_IN_FAILURE = 'CHECK_IN_FAILURE',
}
